/* Great Lakes Lavender Farm — pre-order plant page v1 (v1.1: ship date fills in when the Deposits campaign loads).
   Loaded by snippets/gllf-live-plant-purchase.liquid ONLY for live plants set to "Pre-order available" that use the
   5-step order builder. The builder and the Deposits payment plans are unchanged; this makes the page say "pre-order":
   - a calm "Pre-order · ships from <date>" status under the title (date = the plant's Deposits campaign)
   - the builder is titled "Reserve your plants"; retail is the main choice, wholesale becomes a small link
   - "How pre-orders work" under the builder
   - hides what doesn't fit a plant that is still being grown: red "Re-stocking soon", "Pickup usually ready in
     24 hours", the payment-icon box; volume savings fold into one line (tap to see the table).
   Changes text and layout only; never touches the cart, the form or the payment plans. */
(function () {
  'use strict';
  var me = document.currentScript || document.querySelector('script[data-gllf-preorder-page]');
  if (!me || me.dataset.ran) return;
  me.dataset.ran = '1';
  var PID = me.dataset.productId, SID = me.dataset.sectionId;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function scope() {
    return q('product-info[data-section="' + SID + '"]') || q('#MainProduct-' + SID) || q('#ProductInfo-' + SID) || q('main') || document;
  }
  function shipLine() {
    var r = window.GreatLakesDepositsRules && window.GreatLakesDepositsRules[String(PID)];
    var iso = r && (r.min || r.defaultDate);
    if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return { chip: 'Pre-order', when: '' };
    var d = new Date(iso + 'T12:00:00Z'), today = new Date();
    if (d <= today) return { chip: 'Pre-order · choose your date', when: '' };
    var opts = { month: 'short', day: 'numeric', timeZone: 'UTC' };
    if (d.getUTCFullYear() !== today.getFullYear()) opts.year = 'numeric';
    var label = d.toLocaleDateString('en-US', opts);
    return { chip: 'Pre-order · ships from ' + label, when: label };
  }
  function textOf(el) { return String(el && el.textContent || '').replace(/\s+/g, ' ').trim(); }

  /* v1.1: the Deposits campaign (ship date) can load after this script; update the wording when it does. */
  function refreshDates(root) {
    var s = shipLine(), chip = q('.gllf-po-chip', root), li = q('.gllf-po-how li', root);
    if (chip && chip.textContent !== s.chip) chip.textContent = s.chip;
    var first = 'Pick your size, quantity and ' + (s.when ? 'a ship or pickup date from ' + s.when : 'a ship or pickup date') + '.';
    if (li && li.textContent !== first) li.textContent = first;
  }
  function status(root) {
    if (q('.gllf-po-status', root)) return;
    var h1 = q('h1', root) || q('.product__title', root); if (!h1) return;
    var anchor = h1.closest('.product__title') || h1;
    var s = shipLine();
    var box = document.createElement('div'); box.className = 'gllf-po-status';
    box.innerHTML = '<span class="gllf-po-chip">' + esc(s.chip) + '</span>' +
      '<p>Reserve now and pay a deposit or pay in full. We’ll email you before your plants ship or are ready for pickup.</p>';
    anchor.insertAdjacentElement('afterend', box);
  }

  function bulk(root) {
    var b = q('gllf-bulk-savings', root); if (!b || b.dataset.poDone) return;
    var tiers = qa('.gllf-bulk__tiers > *', b); if (!tiers.length) return;
    b.dataset.poDone = '1'; b.classList.add('gllf-po-bulk', 'is-folded');
    var best = 0; tiers.forEach(function (t) { var m = /save\s+(\d+)%/i.exec(textOf(t)); if (m) best = Math.max(best, +m[1]); });
    var head = q('.gllf-bulk__head', b);
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'gllf-po-bulk__toggle'; btn.setAttribute('aria-expanded', 'false');
    btn.textContent = best ? 'Save up to ' + best + '% on more plants · see savings' : 'See volume savings';
    btn.addEventListener('click', function () {
      var open = b.classList.toggle('is-folded') === false; btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? 'Hide volume savings' : (best ? 'Save up to ' + best + '% on more plants · see savings' : 'See volume savings');
    });
    (head || b).appendChild(btn);
  }

  var payDone = false, payTries = 0;
  function hideBits(root) {
    root.classList.add('gllf-po');
    if (payDone || payTries++ > 30) return;
    /* "Secure Checkout With" + payment icons: shown again at checkout. */
    qa('strong, span, p, div', root).forEach(function (el) {
      if (el.dataset.poPay || !/^Secure\s*Checkout\s*With$/i.test(textOf(el)) || el.children.length > 2) return;
      var box = el; for (var i = 0; i < 4 && box.parentElement && box.parentElement !== root; i++) { box = box.parentElement; if (qa('svg, img', box).length >= 4) break; }
      if (qa('svg, img', box).length >= 4 && box.getBoundingClientRect().height < 260) { box.classList.add('gllf-po-hide'); el.dataset.poPay = '1'; payDone = true; }
    });
  }

  var ORIGINAL = { kick: /^Live plant delivery check$/i, title: /^Where will this plant go\?$/i, sub: /^Five quick steps/i };
  function builder(root) {
    var lp = q('section.gllf-lp', root); if (!lp) return;
    var intro = q('.gllf-lp__intro', lp);
    if (intro) qa(':scope > p, :scope > h2', intro).forEach(function (el) {
      var t = textOf(el);
      if (ORIGINAL.kick.test(t)) { el.textContent = 'Pre-order'; el.classList.add('gllf-po-kick'); }
      else if (ORIGINAL.title.test(t)) el.textContent = 'Reserve your plants';
      else if (ORIGINAL.sub.test(t)) el.textContent = '5 quick steps: delivery, destination, growing, protection, then review. You choose a deposit or pay in full at the end.';
    });
    var retail = q('button[data-retail-mode]', lp), whole = q('button[data-wholesale-mode]', lp);
    if (retail && !retail.dataset.poDone) {
      retail.dataset.poDone = '1'; retail.classList.add('gllf-po-retail');
      var st = q('strong', retail), sm = q('small', retail);
      if (st) st.textContent = 'Pre-order at retail price';
      if (sm) sm.textContent = 'Pick size, delivery and date, then pay a deposit or in full';
    }
    if (whole && !whole.dataset.poDone) {
      whole.dataset.poDone = '1'; whole.classList.add('gllf-po-wholesale');
      var ws = q('strong', whole); if (ws) ws.textContent = 'Ordering for a farm or business? Build a wholesale order';
    }
    if (!q('.gllf-po-how', root)) {
      var how = document.createElement('aside'); how.className = 'gllf-po-how'; how.setAttribute('aria-label', 'How pre-orders work');
      var s = shipLine();
      how.innerHTML = '<b>How pre-orders work</b><ol>' +
        '<li>Pick your size, quantity and ' + (s.when ? 'a ship or pickup date from ' + esc(s.when) : 'a ship or pickup date') + '.</li>' +
        '<li>On the last step, choose: pay a deposit now, or pay in full.</li>' +
        '<li>Check out. We email you before your plants ship or are ready for pickup.</li></ol>' +
        '<p>The deposit amount and when the balance is due are shown before you pay.</p>';
      lp.insertAdjacentElement('afterend', how);
    }
  }

  var busy = false;
  function apply() {
    if (busy) return; busy = true;
    try { var root = scope(); hideBits(root); status(root); bulk(root); builder(root); refreshDates(root); } catch (e) {}
    busy = false;
  }
  function boot() {
    apply();
    /* The builder and the savings box render after load and re-render on changes; re-apply the wording. */
    var root = scope(), pending = false;
    new MutationObserver(function () { if (pending) return; pending = true; requestAnimationFrame(function () { pending = false; apply(); }); })
      .observe(root, { childList: true, subtree: true });
    [400, 1200, 2500, 5000, 9000].forEach(function (ms) { setTimeout(apply, ms); });
    window.addEventListener('load', apply);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
